<template>
  <div>          
    <v-slider color="transparent"  thumb-color="secondary" class="mx-2 my-0" hide-details ref="slider"  thumb-label thumb-size="32" :value="currentValue" @input="changeValue" :min="0" :max="allYos.length > 0?allYos.length-1:0" step=1 >
      <template slot="thumb-label" slot-scope="props">
        <span class="text-[10px] text-center leading-tight">
          <span class="text-[8px]">{{ allYos?.[currentValue]?.glider.replace('GLIDER','G') }}</span><br/>{{allYos?.[currentValue]?.cycle}}
        </span>
      </template>        
    </v-slider>        
    <v-layout v-show="true" caption mx-1 pa-0 justify-center>      
      <v-btn class="mx-0" @click="isPlaying = !isPlaying" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.PlayMissionTooltip')"><v-icon v-html="isPlaying?'mdi-pause':'mdi-play'" ></v-icon></v-btn>
      <v-btn class="mx-0" @click="isPlaying = true" v-if="!isPlaying && currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.ReplayMissionTooltip')"><v-icon>mdi-replay</v-icon></v-btn>
      <v-spacer />
      <span>
        <v-btn class="mx-0" @click="changeValue(0)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToFirstYoTooltip')"><v-icon >mdi-skip-previous</v-icon></v-btn>
        <v-btn class="mx-0" @click="goPrevYo(currentValue)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToPreviousSurfacingYoTooltip')"><v-icon >mdi-chevron-double-left</v-icon></v-btn>        
        <v-btn class="mx-0" @click="changeValue(currentValue-1)" :disabled="currentValue == 0" small icon :title="$t('Pilot.MissionDrawer.GoToPreviousYoTooltip')"><v-icon >mdi-chevron-left</v-icon></v-btn>        
        <span style="display:inline-block;width:97px;text-align:center" v-if="allYos?.[currentValue]?.isUnderWater">{{$t('Pilot.MissionDrawer.Cycle')}} {{allYos?.[currentValue]?.cycle}}</span><template v-else>{{currentDate | formatDate}}</template>
        <v-btn class="mx-0" @click="changeValue(currentValue+1)" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToNextYoTooltip')"><v-icon >mdi-chevron-right</v-icon></v-btn>
        <v-btn class="mx-0" @click="goNextYo(currentValue)" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToNextSurfacingYoTooltip')"><v-icon >mdi-chevron-double-right</v-icon></v-btn>
        <v-btn class="mx-0" @click="changeValue(allYos.length-1)" :disabled="currentValue == allYos.length-1" small icon :title="$t('Pilot.MissionDrawer.GoToLastYoTooltip')"><v-icon >mdi-skip-next</v-icon></v-btn>
      </span>            
    </v-layout>    
  </div> 
</template>
<script setup lang="ts">
  
  import { ref,computed, watch } from 'vue'
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'  
  import store from '@/store'    
  import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'  

  const isPlaying = ref(false)
  const _currentValue = ref(-1)
  
  const currentValue = computed({
    get: () => _currentValue.value == -1?(allYos.value.length > 0?allYos.value.length-1:0): _currentValue.value,
    set: (val) => {
      _currentValue.value = val
    }
  })  

  const props = defineProps<{
    coverageIteration:AloDbCoverageIteration,
    uiid:string}>()
    
  const coverageIterationState = computed(()=> store.myGetters.coverageIterationStateByUiid(props.uiid))  
  const gliderKeys = computed(()=>Object.keys(props.coverageIteration?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))

  const timelineIndex = computed(()=> coverageIterationState.value.timelineIndex)

  const gliderTimelineIndex = computed(()=> gliderKeys.value.map(glider => store.myGetters.coverageIterationMissionUiStateByUiid(buildCoverageIterationMissionUiStateId(props.uiid,glider)).timelineIndex))

  const currentDate = computed(()=> allYos.value?.[currentValue.value]?.date)

  const canUpdateYoIndex = ref(true)

  function changeValue(newValue:number){
    coverageIterationState.value.timelineIndex = newValue
  }
  

  const allYos = computed(()=> 
    gliderKeys.value.reduce((acc, key) => {
      const yos = props.coverageIteration?.resultAloMission?.[key]?.yoArray?.map((y,idx) => ({glider:key,idx,date:y?.yoGpsDatTime,isUnderWater:y?.isUnderWater,cycle:y?.yosCycle})) ?? [] 
      let lastDate = yos?.at(0)?.date!
      yos?.forEach(y => {        
        if(y.date.toString() =='Invalid Date') {           
          y.date = new Date(lastDate.getTime() + 1)
          lastDate = y.date
        }
        else lastDate = y.date
      })
      //@ts-ignore
      return acc.concat(yos)
    },[] as Array<{glider:string,idx:number,date:Date,isUnderWater:boolean,cycle:number}>).sort((a,b) => a.date.getTime() - b.date.getTime())
  )  
  

  function goPrevYo(val:number){
      let yo = null                
      let offset = 1
      while(val-offset >= 0 && (yo = allYos.value[val-offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater)  changeValue(val - offset)
  }

  function goNextYo(val:number){
      let yo = null              
      let offset = 1
      while(allYos.value.length > (val+offset) &&  (yo = allYos.value[val+offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater) changeValue(val + offset)
  }

  

  watch(timelineIndex, (newIndex:number) => {
    checkIndex(newIndex)
  })

  watch(gliderTimelineIndex, (newIndexes:Array<number>,oldIndexes:Array<number>) => {
    if(canUpdateYoIndex.value){      
      //recherche le premier index qui a changé
      let newIndex = newIndexes.findIndex((newIndex,idx) => newIndex != oldIndexes[idx])
      const gliderToFind = gliderKeys.value[newIndex]
      const indexToFind = newIndexes[newIndex]

      const newYos = allYos.value.findIndex(yo => yo.glider == gliderToFind && yo.idx == indexToFind)
      changeValue(newYos)
    }
  })

  watch(isPlaying, (playing:boolean) => {
    if(playing) {  
      //si on reviens au debut on attend que l'animation du curseur de la time line soit fini avant de lancer le play                      
      if(currentValue.value == allYos.value.length - 1) {
        changeValue(0)
        setTimeout(() => play(),350)          
      } 
      else  {                     
        play()
      }
    }      
  })

  function play() {
      if(isPlaying.value) {
        if(currentValue.value == allYos.value.length - 1) {
          isPlaying.value = false
        }
        else{
          changeValue(currentValue.value+1)            
          setTimeout(() => play(),350)
        }     
      }
  }


  
  function checkIndex(newIndex:number) {
    canUpdateYoIndex.value = false
    currentValue.value = newIndex != -1? newIndex : allYos.value.length-1
    //Met à jour la position de chaque glider de la simulation à l'index le plus proche
    gliderKeys.value.forEach(glider => {
      //recherche de l'index le plus proche pour chaque glider   
      let searchIndex = currentValue.value
      let searchYo = null
      while(searchIndex >= 0 &&  (searchYo = allYos.value[searchIndex]).glider != glider) {
        searchIndex--;
      }         
      const coverageIterationMissionUiStateId = buildCoverageIterationMissionUiStateId(props.uiid,glider)
      store.myGetters.coverageIterationMissionUiStateByUiid(coverageIterationMissionUiStateId).timelineIndex = searchYo?.glider == glider?searchYo.idx:0      
      
    })
    setTimeout(() => canUpdateYoIndex.value = true,100)
  }
  


</script> 